import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from '@tanstack/react-query';
import { LookupResponse, ResponseModel } from 'common/interfaces';
import { DriverReactQuery } from '../driver.props';
import { driverRequestConfig } from 'request-config/driver/driver.request-config';
import { GetDriversWithCarProps } from 'request-config/driver/driver.props';
import { QueryHookOptions } from 'hooks/react-query/react-query.props';
import { AxiosResponse } from 'axios';

export const useGetDriversWithCarQuery = (
  props: GetDriversWithCarProps,
  {
    options
  }: QueryHookOptions<
    AxiosResponse<ResponseModel<LookupResponse<'contact'>[]>>,
    ResponseModel<LookupResponse<'contact'>[]>
  > = {}
) => {
  const { fetch } = useFetch<ResponseModel<LookupResponse<'contact'>[]>>({
    loadingKey: `getDriversWithCarQuery${JSON.stringify(props)}`,
    ...driverRequestConfig.getDriversWithCar(props)
  });

  const { data, ...restQueryProps } = useQuery({
    queryKey: [DriverReactQuery.GetDriversWithCar, props],
    queryFn: () => fetch(),
    ...options
  });

  return { getDriversWithCarQuery: data?.data?.data || [], ...restQueryProps };
};
